import { BlitzPage, Routes } from "@blitzjs/next"
import { SButton } from "@superwall-me/sui"
import MakeItRain from "app/core/components/animation/MakeItRain"
import ErrorLayout from "app/core/layouts/Error"
import SplashLayout from "app/core/layouts/Splash"
import { ColorBlur } from "app/splash/components/ColorBlur"
import Header from "app/splash/components/Header"
import { SignUpButton } from "app/splash/components/Main"
import tw from "tailwind-styled-components"

const Title = tw.div`
sm:mt-0
text-[150px]
2xl:text-[200px]
font-medium
md:!leading-tight
bg-clip-text
text-transparent bg-gradient-to-br from-white to-grayscale-lightest
max-w-[500px]
md:max-w-[800px]
lg:max-w-[1000px]"
relative z-[1]
!mb-0
`

const Subtitle = tw.h2`
text-[#9395A1]
text-xl

max-w-[570px]
leading-normal
relative z-[1]
md:px-0
-mt-14
`

const NotFound: BlitzPage = () => {
  return (
    <>
      <Header showBookDemo={true} />
      <MakeItRain />
      <div className="h-screen flex items-center justify-center">
        <ColorBlur fixed={true} />
        <div className="mx-auto  md:mb-10 2xl:mb-14 2xl:py-2 flex flex-col items-center justify-center text-center max-w-5xl gap-10 relative z-1">
          <Title>404</Title>
          <Subtitle>{`Yikes! We can't find the page you're looking for.`}</Subtitle>
          <div className="flex flex-row items-center justify-center gap-10">
            <SignUpButton
              source="404-page"
              mainCta="Start for free"
              bookDemoCta={"Talk to sales"}
              showBookDemo={true}
            ></SignUpButton>
          </div>
        </div>
      </div>
    </>
  )
}

NotFound.getLayout = (page) => <SplashLayout>{page}</SplashLayout>
export default NotFound
